import { RouteRecordRaw } from 'vue-router';

import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { LOCAL_LANDING_PAGE_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';

const routes: LocalizedRoutes = {
  de: { path: LOCAL_LANDING_PAGE_PATH['de'] },
  en: { path: LOCAL_LANDING_PAGE_PATH['en'] },
  fr: { path: LOCAL_LANDING_PAGE_PATH['fr'] },
  it: { path: LOCAL_LANDING_PAGE_PATH['it'] },
};

const Component = () => import('@/pages/LocalLandingPage/LocalLandingEntry.vue');

const localizedRouteConfig = (): RouteRecordRaw[] =>
  generateLocalizedRouteConfig(routes, Component, Pages.LLP);
export default localizedRouteConfig;
